import ResponsiveHelper from '../lib/ResponsiveHelper';
import TouchNav from '../lib/TouchNav';
import '../lib/MobileNav';

// Import bxSlider
import 'bxslider/src/js/jquery.bxslider';

export default class JqueryCode {
	constructor($) {
		// init Mobile Nav
		ResponsiveHelper.addRange({
			'..1024': {
				on() {
					$('body').mobileNav({
						menuActiveClass: 'nav-active',
						menuOpener: '.nav-opener',
						hideOnClickOutside: true,
						menuDrop: '#nav',
					});
				},
				off() {
					$('body').mobileNav('destroy');
				},
			},
		});

		// init Mobile Nav Lang
		ResponsiveHelper.addRange({
			'..1024': {
				on() {
					$('body').mobileNav({
						menuActiveClass: 'lang-active',
						menuOpener: '.lang-opener',
						hideOnClickOutside: true,
						menuDrop: '#lang',
					});
				},
				off() {
					$('body').mobileNav('destroy');
				},
			},
		});

		// handle dropdowns on mobile devices
		$('#nav').each(function () {
			new TouchNav({
				navBlock: this,
			});
		});

		// Platform tabs (topdownload page)
		this.initPlatformTabs($);
	}

	/**
	 * Initialize platform tabs for topdownload page
	 * @param {JQueryStatic} $
	 */
	initPlatformTabs($) {
		const tabs = $('[data-tab-target]');
		const tabContents = $('[data-tab-content]');

		if (tabs.length === 0) {
			return;
		}

		/** @type {Map<string, any>} */
		const sliderInstances = new Map();

		// Initialize bxSlider for each tab content
		tabContents.each(function () {
			const tabType = $(this).data('tabContent');
			const bxsliderEl = $(this).find('.bxslider');

			if (bxsliderEl.length) {
				const slider = bxsliderEl.bxSlider({
					minSlides: 1,
					maxSlides: 1,
					slideMargin: 22,
					nextText: '',
					prevText: '',
					pager: true,
					preventDefaultSwipeY: false,
					infiniteLoop: true,
					adaptiveHeight: false,
				});

				sliderInstances.set(tabType, slider);
			}
		});

		// Check for anchor link in URL (e.g., #desktop-tab, #android-tab, #ios-tab)
		const validTabTypes = ['#desktop-tab', '#android-tab', '#ios-tab'];
		const isValidHash =
			Boolean(location.hash) && validTabTypes.includes(location.hash);

		// Determine which tab to show: from URL hash or auto-detect OS
		const activeTabType = isValidHash
			? location.hash.slice(1).replace('-tab', '')
			: this.getOS();

		const defaultTab = $(`[data-type="${activeTabType}"]`);
		const defaultContent = $(`[data-tab-content="${activeTabType}"]`);

		if (defaultTab.length && defaultContent.length) {
			tabs.removeClass('active');
			tabContents.removeClass('active');
			defaultTab.addClass('active');
			defaultContent.addClass('active');

			// Redraw the active slider
			const activeSlider = sliderInstances.get(activeTabType);
			if (activeSlider) {
				setTimeout(() => activeSlider.redrawSlider(), 0);
			}

		}

		/**
		 * Scroll to a section smoothly
		 * @param {string} selector
		 */
		const scrollToSection = (selector) => {
			const section = $(selector);
			if (section.length) {
				$('html, body').animate(
					{
						scrollTop: section.offset().top - 80,
					},
					500
				);
			}
		};

		// Scroll to section if page was loaded with a tab hash
		if (isValidHash) {
			setTimeout(() => {
				scrollToSection('.how-to-install');
			}, 100);
		}

		/**
		 * Activate a tab by type
		 * @param {string} tabType
		 * @param {boolean} shouldScroll
		 */
		const activateTab = (tabType, shouldScroll = false) => {
			// Update tab active states
			tabs.removeClass('active');
			$(`[data-type="${tabType}"]`).addClass('active');

			// Update tab content visibility
			tabContents.removeClass('active');
			$(`[data-tab-content="${tabType}"]`).addClass('active');

			// Update URL hash without triggering scroll
			history.replaceState(null, '', `#${tabType}-tab`);

			// Redraw the slider for the newly active tab
			const slider = sliderInstances.get(tabType);
			if (slider) {
				setTimeout(() => slider.redrawSlider(), 0);
			}

			// Scroll to section if requested
			if (shouldScroll) {
				scrollToSection('.how-to-install');
			}
		};

		// Tab click handler
		tabs.on('click', function (e) {
			e.preventDefault();
			const tabType = $(this).data('type');
			activateTab(tabType, false);
		});

		// Handle browser back/forward navigation
		$(window).on('hashchange', function () {
			if (validTabTypes.includes(location.hash)) {
				const tabType = location.hash.slice(1).replace('-tab', '');
				activateTab(tabType, true);
			}
		});
	}

	/**
	 * Detect user's operating system
	 * @returns {'android'|'ios'|'desktop'}
	 */
	getOS() {
		const ua = navigator.userAgent || navigator.vendor || window.opera;
		if (/android/i.test(ua)) return 'android';
		if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';
		return 'desktop';
	}
}
